import Container from './ReactionList.container';
import ReactionList from './ReactionList';
export default Container(ReactionList);
